// Quick-select shortcuts for the DateRangePicker filters, replacing rsuite's
// defaults (Today / Yesterday / Last 7 Days). Approvals are read by month and
// by year far more often than by day, so the shortcuts follow calendar
// boundaries rather than rolling day counts — the one exception being the last
// week, which is how a queue is usually skimmed.

import { formatPeriodLabel, toDateOnlyString, toStartOfDay } from './payPeriods';

const daysBefore = (date, days) => {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() - days);
  return shifted;
};

// Month and year bounds built from parts rather than by adding days, so they
// land correctly across month lengths, leap years and DST.
const monthBounds = (year, monthIndex) => [
  new Date(year, monthIndex, 1),
  new Date(year, monthIndex + 1, 0),
];

const yearBounds = (year) => [new Date(year, 0, 1), new Date(year, 11, 31)];

// Built on demand rather than as a constant: "this month" is only true for as
// long as the tab has been open.
export const getQuickDateRanges = () => {
  const today = toStartOfDay(new Date());
  const year = today.getFullYear();
  const month = today.getMonth();

  return [
    { label: 'Last 7 Days', value: [daysBefore(today, 6), today] },
    { label: 'This Month', value: monthBounds(year, month) },
    { label: 'Last Month', value: monthBounds(year, month - 1) },
    { label: 'This Year', value: yearBounds(year) },
    { label: 'Last Year', value: yearBounds(year - 1) },
  ];
};

// Sunday-to-Saturday weeks, matching weekStart={0} on the app's date pickers.
// Shaped like getPayPeriodOptions() ("start|end" values) so PayPeriodSelect can
// list them as-is. Newest first, starting from the week in progress.
export const getWeekOptions = ({ weeksBack = 26 } = {}) => {
  const today = toStartOfDay(new Date());
  const sunday = daysBefore(today, today.getDay());

  const options = [];
  for (let offset = 0; offset <= weeksBack; offset += 1) {
    const start = daysBefore(sunday, offset * 7);
    const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
    options.push({
      value: `${toDateOnlyString(start)}|${toDateOnlyString(end)}`,
      label: formatPeriodLabel(start, end),
      start,
      end,
    });
  }
  return options;
};
